import { render, staticRenderFns } from "./groupFitnessDashboard.vue?vue&type=template&id=86ba4aa4"
import script from "./groupFitnessDashboard.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports